// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amp-layout__wrapper .article-sticker__name{font-size:14px;line-height:14px}.amp-layout__wrapper .article-sticker__img{margin:0}", ""]);
// Exports
module.exports = exports;
